/* import __COLOCATED_TEMPLATE__ from './series-body.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();